export default __webpack_public_path__ + "static/media/music-starting.20be1229.png";